import { useMediaQuery } from '@mui/material';

import smallLogo from '../../configs/images/Logo.png';
import largeLogo from '../../configs/images/Logo2.png';
import theme from '../../configs/theme';

export default function Logo() {
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    
    return (
        <img 
            src={isSmallScreen ? smallLogo : largeLogo} 
            alt="Logo" 
            style={{ 
                width: isSmallScreen ? "100%" : "25vw", 
                height: "auto" 
            }} 
        />
    );
}